'use strict';

function AdminUsersUpdateController(userService, $translate) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.updateUser = updateUser;
  vm.loading = false;
  vm.translationsDone = false;

  function $onInit() {
    vm.me = vm.me || {};
    vm.user = {};

    userService.get(vm.id).then(function (user) {
      vm.user = user;
    });

    userService.getGroups().then(function (groups) {
      vm.groups = groups;
      $translate('groups').then(function () {
        vm.translationsDone = true;
      });
    });
  }

  function updateUser(user, form) {
    vm.loading = true;
    userService.update(vm.id, user)
      .catch(function (response) {
        Object.keys(response.data).forEach(function (input) {
          form[input].$setValidity(input, false);
        });
      })
      .finally(function () {
        vm.loading = false;
      });
  }
}

module.exports = AdminUsersUpdateController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/update/update.controller.js
 ** module id = 158
 ** module chunks = 0
 **/